import { ACCOUNT_FLAGS_PRIORITY_MAP, ACCOUNT_FLAGS_SUPPORT_MAP } from '../constants';
import { FlagType } from '../types';

export const processAccountFlags = (
  accountFlags: {
    name: string;
    type: FlagType;
    token: string | null;
  }[],
  processedAccountFlags: string[]
) =>
  accountFlags
    .filter((entry) => ACCOUNT_FLAGS_SUPPORT_MAP.includes(entry.name) && !processedAccountFlags.includes(entry.name))
    .map((entry) => ({
      ...entry,
      priority: ACCOUNT_FLAGS_PRIORITY_MAP[entry.name] || Number.POSITIVE_INFINITY,
    }))
    .sort((a, b) => {
      if (a.type === b.type) {
        return a.priority - b.priority;
      } else if (a.type === FlagType.HARD && b.type === FlagType.SOFT) {
        return -1;
      } else if (a.type === FlagType.SOFT && b.type === FlagType.HARD) {
        return 1;
      }

      return 0;
    })
    .map((entry) => ({ name: entry.name, type: entry.type, token: entry.token }));
